// Project-level role badge — renders a User#role enum value as a
// semantic outline badge. Centralizes role → label / palette mapping so
// individual pages don't reinvent it (and don't drift in dark-mode
// handling).
//
// Roles map to:
//   super_admin — destructive token (elevated power, "use with care")
//   boghma      — violet (internal Boghma team — kept as raw color since
//                 it's a single brand-identity tag and doesn't earn its
//                 own theme token)
//   developer   — info token (plugin developer / collaborator)
//   user        — muted (default tier, neutral signal)
//
// Returns `null` only for unknown roles so call sites can drop the
// component in unconditionally.

import { cn } from "@/components/shadcn/lib/utils"
import { Badge } from "@/components/shadcn/ui/badge"

const ROLES = {
  super_admin: {
    label: "Super Admin",
    className: "bg-destructive/10 text-destructive border-destructive/30",
  },
  boghma: {
    label: "Boghma",
    className:
      "bg-violet-500/10 text-violet-600 dark:text-violet-400 border-violet-500/30",
  },
  developer: {
    label: "Developer",
    className: "bg-info/10 text-info border-info/30",
  },
  user: {
    label: "User",
    className: "bg-muted/60 text-muted-foreground border-border/60",
  },
}

export function RoleBadge({ role, className, ...props }) {
  const config = ROLES[role]
  if (!config) return null
  return (
    <Badge
      variant="outline"
      className={cn("text-xs font-medium", config.className, className)}
      {...props}
    >
      {config.label}
    </Badge>
  )
}
